export enum KnmModalsEnum {
  ERKNM_ATTACH_WEB_DOCUMENT_MODAL = 'ERKNM_ATTACH_WEB_DOCUMENT_MODAL',
  COPY_KNM_MODAL = 'COPY_KNM_MODAL',
  CHANGE_STATUS_MODAL_TO_REVISION = 'CHANGE_STATUS_MODAL_TO_REVISION',
  CHANGE_STATUS_MODAL_TO_APPROVE = 'CHANGE_STATUS_MODAL_TO_APPROVE',
  SIGN_MODAL = 'SIGN_MODAL',
  SIGN_UPLOAD_MODAL = 'SIGN_UPLOAD_MODAL',
  ACCESS_SETTINGS = 'ACCESS_SETTINGS',
  DICTIONARY_KNO_ORGANISATIONS = 'DICTIONARY_KNO_ORGANISATIONS',
  ACCESS_RESTRICTION_NOTICE = 'ACCESS_RESTRICTION_NOTICE',
  ACCESS_DENIED_FOR_TEST = 'ACCESS_DENIED_FOR_TEST',
  ACCESS_DENIED_PLAN_FOR_TEST = 'ACCESS_DENIED_PLAN_FOR_TEST',
  APPROVE_ADD_NOTIFICATION_MODAL = 'APPROVE_ADD_NOTIFICATION_MODAL',
  KNM_CANCELLED_MODAL = 'KNM_CANCELLED_MODAL',
  KNM_EXCLUDE_MODAL = 'KNM_EXCLUDE_MODAL',
  ERKNM_COPY_MODAL = 'ERKNM_COPY_MODAL',
  ERKNM_PRESCRIBE_CANCEL = 'ERKNM_PRESCRIBE_CANCEL',
  ERKNM_ACT_CANCEL = 'ERKNM_ACT_CANCEL',
  ERKNM_FINISH_RO_PASSPORT = 'ERKNM_FINISH_RO_PASSPORT',
  PM_OP_CANCEL_WARNING_PASSPORT = 'PM_OP_CANCEL_WARNING_PASSPORT',
  ERKNM_SIGN_AFTER_CANCEL = 'ERKNM_SIGN_AFTER_CANCEL',
}
